import { GetStaticPaths, GetStaticProps } from 'next';
import { title } from 'process';
import React from 'react';
import { ICompetition } from '~/../../core/types';
import CompetitionService from '~/api/services/competitionService';
import VideoCard from '~/components/cards/VideoCard';
import { CtaButton, CtaColorScheme } from '~/components/cta/regular';
import { CustomHead } from '~/components/Head';
import PageHeaderLayout from '~/components/layouts/PageHeaderLayout';
import StaticPageLayout from '~/components/layouts/StaticPageLayout';
import ElegantModal from '~/components/modals/ElegantModal';
import CompetitionResults from '~/components/pages/CompetitionResults';
import VideoPlayback from '~/components/VideoPlayer/VideoPlayback';
import WfaVote from '~/pages/wedding-film-awards/vote';
import { getQueryParam } from '~/utils/url';

interface Props {
  year: number;
  awardStatus: string;
  competition: ICompetition;
  competitionDates?: any[]

}


const CompetitionResultsPage = (props: Props) => {
  return <CompetitionResults {...props} />;
};

export const getStaticProps: GetStaticProps<Props> = async ({ params }) => {
  const slug = 'wedding-film-awards';
  const year = getQueryParam(params, 'year');
  const awardStatus = getQueryParam(params, 'awardStatus');
  const competition = await (async () => {
    try {
      return await CompetitionService.getCompetitionResults(slug, parseInt(year));
    } catch (e) {
      if (e.response?.status === 404) 
        return undefined;
      throw e;
    }
  })();

  const competitionDates = await (async () => {
    try {
      return await CompetitionService.getCompetitionDates();
    } catch (e) {
      if (e.response?.status === 404) 
        return undefined;
      throw e;
    }
  })();


  if (competition === undefined || competitionDates === undefined) {
    return {
      notFound: true,
      revalidate: 30,
    };
  }

  if (awardStatus !== 'finalists' && awardStatus !== 'winners') {
    return {
        notFound: true,
        revalidate: 30,
      };
  }

  return {
    props: {
      year: parseInt(year),
      awardStatus: awardStatus,
      competition: competition,
      competitionDates: competitionDates,
    },
    revalidate: 360,
  };
};

export const getStaticPaths: GetStaticPaths = async () => {
    return {
      paths: [],
      fallback: 'blocking',
    };
  };

export default CompetitionResultsPage;
